var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "area" }, [
    _c("h1", [_vm._v("404 - NOT FOUND!!!")]),
    _c("p", [_vm._v("The page you are looking for could not be found.")]),
    _c(
      "ul",
      { staticClass: "circles" },
      _vm._l(10, function(item, index) {
        return _c("li", { key: index })
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }